import { RHFControl, RHFSelect, RHFDatePicker, RHFDocumentUpload } from 'components/common/form';
import { Card, Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSponsorshipConditions } from 'hooks/useBeneficiaries';

export const HealthConditionCard = ({ sectionRef, sideNavLink }) => {
  const { sponsorshipConditions } = useSponsorshipConditions();

  const conditionsOptions = useMemo(
    () =>
      sponsorshipConditions?.map(({ condition, id }) => {
        return {
          label: condition,
          value: id
        };
      }),
    [sponsorshipConditions]
  );

  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <div className="dFlexRowStartSpace pt-3">
          <Card.Title as="h5">Health Condition</Card.Title>
        </div>
      </Card.Header>
      <Card.Body>
        <Container className="p-0 d-flex flex-column g-3">
          <Row className="g-3">
            <Col xs={12} sm={6} md={4}>
              <RHFSelect
                name="healthCondition"
                label="Condition"
                options={conditionsOptions}
                required
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFDatePicker
                name="medicalAssessedDate"
                label="Date Assessed"
                clearable
              />
            </Col>
            <Col xs={12}>
              <RHFDocumentUpload
                name="medicalDocuments"
                label="Supporting Documents"
                accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                multiple={true}
                maxFiles={5}
                maxSizeMB={10}
              />
            </Col>
          </Row>
          <Row className="g-3">
            <Col xs={12}>
              <RHFControl
                label="Medical Notes / Requirements"
                name="medicalNotes"
                as="textarea"
                rows={3}
                placeholder="Enter any medical requirements or additional health information..."
              />
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};

HealthConditionCard.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string
};
